var map = {
	"./N3Lexer": 27,
	"./N3Lexer.js": 27,
	"./N3Parser": 28,
	"./N3Parser.js": 28,
	"./N3Store": 45,
	"./N3Store.js": 45,
	"./N3StreamParser": 46,
	"./N3StreamParser.js": 46,
	"./N3StreamWriter": 56,
	"./N3StreamWriter.js": 56,
	"./N3Util": 29,
	"./N3Util.js": 29,
	"./N3Writer": 33,
	"./N3Writer.js": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;


//////////////////
// WEBPACK FOOTER
// ./node_modules/n3/lib ^\.\/N3.*$
// module id = 69
// module chunks = 0